export default "__VITE_ASSET__KOG5_jjs__"